import React, { useState, useEffect } from "react";
import {Grid } from '@material-ui/core';
import { Box, Card, CardContent, FormControl, InputLabel, Alert, AlertTitle, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Select, MenuItem } from '@mui/material';
import MainCard from '../components/MainCard';
import StickyHeadTwoButtonTable from '../components/StickyHeadTwoButtonTable';
import axios from "../../components/axios";
import { useNavigate } from 'react-router-dom';
import PieChart from '../components/Chart/PieChart';


const AmberExternalPage = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [releaseRows, setReleaseRows] = useState([]);
  const [suiteRows, setSuiteRows] = useState([]);
  const [showTable, setshowTable] = useState(false);
  const [showAlert, setshowAlert] = useState(false);
  const [showReleaseTable, setshowReleaseTable] = useState(false);
  const [showReleaseAlert, setshowReleaseAlert] = useState(false);
  const [showRelease, setshowRelease] = useState(false);
  const [showDialogDelete, setShowDialogDelete] = useState(false);
  const [deleteItemID, setDeleteItemID] = useState('');
  const [noDataMessage, setNoDataMessage] = useState('');
  const threshold = 1000;
  const exportURL = '/peloton/v1/automation/test-report-csv';
  const [fullQuery, setFullQuery] = useState('');
  const [openSummary, setOpenSummary] = useState(false);
  const [openRelease, setOpenRelease] = useState(false);
  const [series, setSeries] = useState([]);
  const [total, setTotal] = useState(0);
  const [pass, setPass] = useState(0);
  const [fail, setFail] = useState(0);
  const [skip, setSkip] = useState(0);
  const isOTA = '0';
  const shareAPI = 'image-share-link';
  const showShare = false;
  const showSummary = true;
  const internalOnlyList = [
    { value: 'Internal'},
  ];
  const bothOnlyList = [
    { value: 'Internal'},
    { value: 'External'},
  ];
  const [projectList, setProjectList] = useState([]);
  const [project, setProject] = useState("");
  function handleProject(e) {
        setProject(e.target.value);
        setPrefix("");
        setPostfix("");
        setSuite("");
        if (e.target.value === "Amber" || e.target.value === "Redstone" || e.target.value === "Topaz11" ){
          setPrefixList(bothOnlyList);
        }else{
          setPrefixList(internalOnlyList)
        }
  }

  const [prefixList, setPrefixList] = useState([]);
  const [prefix, setPrefix] = useState("");
  function handlePrefix(e) {
    let prefixVal = e.target.value;
    setPrefix(prefixVal);
    if (project !== "" || prefixVal !== "" ){
      setSuite("All");
      getImageOptions(project, prefixVal);
    }else{
      setPostfixList([]);
    }
  }

  const [postfixList, setPostfixList] = useState([]);
  const [postfix, setPostfix] = useState("");
  function handlePostfix(e) {
        setPostfix(e.target.value);
        getSuiteOptions(project, prefix, e.target.value);
  }

  const [suiteList, seSuiteList] = useState([]);
  const [suite, setSuite] = useState("All");
  function handleSuite(e) {
        setSuite(e.target.value);
  }

  const [mapSuiteChart, setMapSuiteChart] = useState(new Map());
  const [testSuiteList, setTestSuiteList] = useState([]);
  const [testSuite, setTestSuite] = useState("All Suites");

  const handleClose = () => {
    setOpenSummary(false);
    setOpenRelease(false);
    setTestSuite('All Suites');
  };

  const styleButton = {
    backgroundColor: "#406599",
    color: "#fff",
    borderRadius: "5px",
    boxSizing: "border-box",
    width: "100px",
    height: "45px",
    fontFamily: '"Roboto", "sans-serif"',
    fontSize: "15px",
  };

  const styleField = {
    width: '100%',
  };

  const getVersionOptions = async () => {
    const response = await axios.post("/peloton/v1/automation/build-filter-options", null, { withCredentials: true});
    if (response.data.project_options !== null) {
      setProjectList(response.data.project_options);
    }
  }

  const getImageOptions= async (project, image_type) => {
    var input_data = JSON.stringify({ project: project, image_type: image_type})
    const response = await axios.post("/peloton/v1/automation/image-version-options", input_data, { withCredentials: true});
    if (response.data.postfix_options !== null) {
      setPostfixList(response.data.postfix_options);
    }else{
      setPostfixList([]);
    }
  }

  const getSuiteOptions= async (project, image_type, version) => {
    var input_data = JSON.stringify({ project: project, image_type: image_type, image_version: version})
    const response = await axios.post("/peloton/v1/automation/build-suite-options", input_data, { withCredentials: true});
    if (response.data.postfix_options !== null) {
      seSuiteList(response.data.suite_options);
    }else{
      seSuiteList([]);
    }
  }

  useEffect(() => {
    getVersionOptions();
  }, []);

  const handleDownload = (uuid) => {
      var input_data = JSON.stringify({ item_uuid: uuid })
      axios.post("/peloton/v1/automation/test-report-file", input_data, {withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          window.open(response.data.url, "_blank");
        }else{
            alert(response.data.message);
        }
      })
      .catch(function(err){
        if (!err.response){
          alert(err);
        }else{
          if (err.response.status === 401){
            navigate("/");
          }else{
            console.log('error.response.status: ', err.response.status);
            console.log('error.response.status: ', err.response.data.message);
            alert(err.response.data.message);
          }
        }
      })
  };

  const handleDownloadReleaseNote = (id) => {
      var input_data = JSON.stringify({ id: id })
      axios.post("/peloton/v1/automation/amber-release-note", input_data, {withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          window.open(response.data.url, "_blank");
        }else{
            alert(response.data.message);
        }
      })
      .catch(function(err){
        if (!err.response){
          alert(err);
        }else{
          if (err.response.status === 401){
            navigate("/");
          }else{
            console.log('error.response.status: ', err.response.status);
            console.log('error.response.status: ', err.response.data.message);
            alert(err.response.data.message);
          }
        }
      })
  };

  const handleRedirect = (uuid) => {
      var input_data = JSON.stringify({ item_uuid: uuid });
      axios.post("/peloton/v1/automation/test-report-pages", input_data, {withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          window.open(process.env.REACT_APP_API_URL+response.data.url, "_blank");
        }else{
          alert(response.data.message);
        }
      })
      .catch(function(err){
        if (!err.response){
          alert(err);
        }else{
          if (err.response.status === 401){
            navigate("/");
          }else{
            console.log('error.response.status: ', err.response.status);
            console.log('error.response.status: ', err.response.data.message);
            alert(err.response.data.message);
          }
        }
      })
  };

  const handleQueryData = () => {
    if (prefix === "" || postfix === "" ){
      alert("Please select prefix and date!");
    }else{
      setTotal(0);
      setPass(0);
      setFail(0);
      setSkip(0);
      setSeries([]);
      setRows([]);
      setReleaseRows([]);
      var input_data = JSON.stringify({ project: project, image_type: prefix, image_version: postfix, is_release: true, suite_name: suite})
      setFullQuery(input_data);
      axios.post("/peloton/v1/automation/image-version-report",input_data,{withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          if (response.data.data !== null && response.data.data.length > 0){
            if (response.data.data.length >threshold){
                setshowAlert(true);
                setNoDataMessage('More than 1000 rows, please click "Export Data" to download file')
            }else{
              setRows(response.data.data);
              setshowAlert(false);
            }
            setTestSuiteList(response.data.suite_options);
            setMapSuiteChart(map => new Map(Object.entries(response.data.suite_chart)));
            setTotal(response.data.total_count);
            setPass(response.data.pass_count);
            setFail(response.data.fail_count);
            setSkip(response.data.skip_count);
            setSeries([response.data.pass_count, response.data.fail_count, response.data.skip_count]);
            setSuiteRows(response.data.suite_record);
            setshowTable(true);
          }else{
            setNoDataMessage('This image has no test log.')
            setshowAlert(true);
          }
          if (response.data.release_note !== null && response.data.release_note.length > 0){
            setReleaseRows(response.data.release_note);
            setshowReleaseAlert(false);
            setshowReleaseTable(true);
            setshowTable(true);
            setshowRelease(true);
          }else{
            setshowReleaseAlert(true);
            setshowRelease(false);
          }
        }else{
          alert(response.data.message);
        }
      }).catch(err => {
        if (err.message === 'timeout of 3000ms exceeded'){
          setshowAlert(true);
          setNoDataMessage('Too many rows, please click "Export Data" to download file')
          setshowTable(true);
        }else{
          if (!err.response){
            alert(err)
          }else{
            if (err.response.status === 401){
              navigate("/");
            }else{
              alert(err.response.data.message);
            }
          }
        }
      })
    }
  };

  const handleSummary = () => {
    setOpenSummary(true)
  };

  const handleRelease = () => {
    setOpenRelease(true)
  };

  const handleDelete = (row) => {
    setDeleteItemID(row.uuid);
    setShowDialogDelete(true);
  };

  const deleteTestRecord = () => {
    var input_data = JSON.stringify({ item_uuid: deleteItemID });
      axios.post("/peloton/v1/automation/remove-test-record", input_data, {withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          handleQueryData()
        }else{
          alert(response.data.message);
        }
      }).catch(function(err){
        if (!err.response){
          alert(err);
        }else{
          if (err.response.status === 401){
            navigate("/");
          }else{
            console.log('error.response.status: ', err.response.status);
            console.log('error.response.status: ', err.response.data.message);
            alert(err.response.data.message);
          }
        }
    })
    .finally(() => {
      setDeleteItemID('');
      setShowDialogDelete(false);
    });
  }

  const handleDeleteClose = () => {
    setShowDialogDelete(false);
  };

const columns = [
  { id: 'serial_number', label: 'Serial Number', align: 'left' },
  { id: 'start_time', align: 'center', label: 'Start Time'},
  { id: 'end_time', align: 'center', label: 'End Time'},
  { id: 'platform', align: 'center', label: 'platform'},
  { id: 'suite_name', align: 'center', label: 'Suite Name'},
  { id: 'system_image', align: 'center', label: 'System Image'},
  { id: 'system_image_type', align: 'center', label: 'Image Type'},
  { id: 'total', align: 'center', label: 'Total'},
  { id: 'pass', align: 'center', label: 'Pass'},
  { id: 'fail', align: 'center', label: 'Fail'},
  { id: 'skip', align: 'center', label: 'Skip'},
  { id: 'action', label: 'Download', align: 'center', action: true},
  { id: 'view', label: 'Show', align: 'center', view: true },
  { id: 'ignore', label: 'Ignore', align: 'center', ignore: true },
];

const releaseColumns = [
  { id: 'from', align: 'center', label: 'Start version'},
  { id: 'to', align: 'center', label: 'End version'},
  { id: 'action', label: 'Download', align: 'center', action: true},
];

  return (
    <MainCard title="Build Filter">
      <Card variant="outlined" sx={{ bgcolor: "white" }}>
      <CardContent>
      <Box sx={{ fontSize: '20px', color:"#406599", pb:'15px'}}>
      Build Filter
      </Box>
      <Grid container direction="row" justifyContent="space-around" alignItems="center" >
        <Grid item xs={1}>
        </Grid>
        <Grid item xs={2}>
          <FormControl style={styleField} >
          <InputLabel id="demo-simple-select-standard-label">Select Project</InputLabel>
            <Select
              id="prefix"
              fullWidth
              value={project}
              onChange={handleProject}
              variant="filled"
            >
              {projectList.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.value}
                </MenuItem>
              ))}
            </Select>
            </FormControl>
        </Grid>
        <Grid item xs={2}>
          <FormControl style={styleField} >
          <InputLabel id="demo-simple-select-standard-label">Select Type</InputLabel>
            <Select
              id="prefix"
              fullWidth
              value={prefix}
              onChange={handlePrefix}
              variant="filled"
            >
              {prefixList.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.value}
                </MenuItem>
              ))}
            </Select>
            </FormControl>
            </Grid>
            <Grid item xs={2}>
            <FormControl style={styleField} >
            <InputLabel id="demo-simple-select-standard-label">Select Image</InputLabel>
              <Select
                id="postfix"
                fullWidth
                value={postfix}
                onChange={handlePostfix}
                variant="filled"
              >
                {postfixList.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={2}>
            <FormControl style={styleField} >
            <InputLabel id="demo-simple-select-standard-label">Select Suite</InputLabel>
              <Select
                id="postfix"
                fullWidth
                value={suite}
                onChange={handleSuite}
                variant="filled"
              >
                {suiteList.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        <Grid item xs={1}>
          <Dialog open={openSummary} onClose={handleClose} maxWidth='md' scroll='body' aria-labelledby="scroll-dialog-title" aria-describedby="scroll-dialog-description" >
            <PieChart series={series} total={total} pass={pass} fail={fail} skip={skip} fullQuery={fullQuery} isShareable={true} shareAPI={shareAPI} testSuiteList={testSuiteList} mapSuiteChart={mapSuiteChart} setTotal={setTotal} setPass={setPass} setFail={setFail} setSkip={setSkip} setSeries={setSeries} testSuite={testSuite} setTestSuite={setTestSuite} suiteRows={suiteRows} imageName={postfix}/>
          </Dialog>

          <Dialog open={showDialogDelete} onClose={handleDeleteClose} fullWidth>
            <DialogTitle id="alert-dialog-title">
              {"Confirm delete"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
              Are you sure you want to ignore this test record ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDeleteClose}>Cancel</Button>
              <Button onClick={deleteTestRecord} autoFocus>
                Ignore
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog open={openRelease} onClose={handleClose} fullWidth>
            { showReleaseTable && (<StickyHeadTwoButtonTable rows={releaseRows} columns={releaseColumns} handleDownload={handleDownloadReleaseNote}/>)}
            { showReleaseAlert && (<Card variant="outlined" sx={{ bgcolor: "white" }}><Alert severity="warning">
        <AlertTitle>Warning</AlertTitle>No release note to this version.</Alert></Card>)}
          </Dialog>
        </Grid>
        <Grid item xs={1}>
          <Button style={styleButton} onClick={handleQueryData}>Search</Button>
        </Grid>
      </Grid>
      </CardContent>
      </Card>
      { showTable && (<StickyHeadTwoButtonTable rows={rows} columns={columns} handleDownload={handleDownload} handleRedirect={handleRedirect} exportURL={exportURL} fullQuery={fullQuery} showSummary={showSummary} handleSummary={handleSummary} isOTA={isOTA} showShare={showShare} shareAPI={shareAPI} handleRelease={handleRelease} showRelease={showRelease} handleDelete={handleDelete}/>)}
      { showAlert && (<Card variant="outlined" sx={{ bgcolor: "white" }}><Alert severity="warning">
        <AlertTitle>Warning</AlertTitle>
        {noDataMessage}
      </Alert></Card>)}
    </MainCard>)
};

export default AmberExternalPage;
